module.exports = __webpack_public_path__ + "img/0_icon-zb.28ecfa59.svg";